<template>
  <div>
    <LoginLayout
      :loginHeading="'Enter 2FA Code'"
      :primaryButtonText="'Login'"
      :loginErrorMessage="loginError.message"
      :showErrorMessage="loginError.show"
      :showSwitchUser="true"
      :logUserIn="logUserIn"
      :customImage="qrcode"
      @submit="loginToServicePanel"
      @switchUser="switchUser"
    >
      <form class="mt-3" @submit.prevent="loginToServicePanel()" @keyup.enter="loginToServicePanel()" autocomplete="off">
        <div class="row row-spacing">
          <h4 class="col-12 text-center mb-3">OTP</h4>
          <div class="col-12">
            <div class="input-group mb-3">
              <input type="text" class="form-control input-bg text-center" ref="otpInputA" placeholder="_" v-model="otpA" maxlength="1" @input="handleInput($event, 'A', 'B')" @keydown="handleKeydown($event, 'A', null)" @paste="handlePaste">
              <input type="text" class="form-control input-bg text-center" ref="otpInputB" placeholder="_" v-model="otpB" maxlength="1" @input="handleInput($event, 'B', 'C')" @keydown="handleKeydown($event, 'B', 'A')" @paste="handlePaste">
              <input type="text" class="form-control input-bg text-center" ref="otpInputC" placeholder="_" v-model="otpC" maxlength="1" @input="handleInput($event, 'C', 'D')" @keydown="handleKeydown($event, 'C', 'B')" @paste="handlePaste">
              <input type="text" class="form-control input-bg text-center" ref="otpInputD" placeholder="_" v-model="otpD" maxlength="1" @input="handleInput($event, 'D', 'E')" @keydown="handleKeydown($event, 'D', 'C')" @paste="handlePaste">
              <input type="text" class="form-control input-bg text-center" ref="otpInputE" placeholder="_" v-model="otpE" maxlength="1" @input="handleInput($event, 'E', 'F')" @keydown="handleKeydown($event, 'E', 'D')" @paste="handlePaste">
              <input type="text" class="form-control input-bg text-center" ref="otpInputF" placeholder="_" v-model="otpF" maxlength="1" @input="handleInput($event, 'F', null)" @keydown="handleKeydown($event, 'F', 'E')" @paste="handlePaste">
            </div>
          </div>
        </div>
      </form>
    </LoginLayout>
  </div>
</template>

<script>
import LoginLayout from '@/layouts/LoginLayout';
  export default {
    components: {
      LoginLayout
    },
    data() {
      return {
        loginCredentials: {
          userName: "",
          password: "",
          otp: null
        },
        loginError: {
          message: "",
          show: false
        },
        qrcode: '',
        logUserIn: false,
        otpStatus: '',

        otpA: "",
        otpB: "",
        otpC: "",
        otpD: "",
        otpE: "",
        otpF: "",
      }
    },
    mounted() {
      document.title = "Login | Service Panel"
      const redirectToken = this.$route.query.token

      this.loginCredentials.userName = atob(this.$localStorage.get("uli"));
      this.loginCredentials.password = atob(this.$localStorage.get("pli"));
      this.otpStatus = this.$localStorage.get("otp");

      if (this.otpStatus == "TOTP_ONBOARD") {
          this.qrcode = this.$localStorage.get("qrc");
      }
      
      if (redirectToken) {
        const redirectDetail = atob(redirectToken);
        const redirectDetails = redirectDetail.split(":");
        this.$localStorage.set("temp-token", redirectDetails[0]);
        
        this.$localStorage.remove("uli");

        this.goToSale(redirectDetails[1]);
      } else {
        this.fromRoute = this.$route.params.fromRoute;

        if (this.$route.query.tokenIssue === "1") {
          this.loginError.message = "You have been logged out due to an Authentication issue, please try logging in again.";
          this.loginError.show = true;
        } else {
          const storedToken = this.$localStorage.get("aims-token");
          if (storedToken) {
            this.goToServicePanelDashboard();
          }
        }
      }
      
      this.$refs.otpInputA.focus();
    },
    methods: {
      loginToServicePanel: function() {
        this.loginError.show = false;
        this.logUserIn = true;

        this.$http.post(this.$config.aimsAPIv2 + "login", this.loginCredentials).then(
          (response) => {
            this.logUserIn = false;

            if (response.body.status == "SUCCESSFUL") {

              this.$localStorage.set("aims-token", response.body.token);
              this.$localStorage.set("uli", btoa(this.loginCredentials.userName));

              this.$localStorage.remove("pli");
              this.$localStorage.remove("otp");
              this.$localStorage.remove("qrc");

              if (this.$localStorage.get("OG_URL")) {
                this.$router.replace(this.$localStorage.get("OG_URL"));
              } else {
                this.$router.replace({
                  name: "dashboard",
                });
              }

            }
          },
          (response) => {
            if (response.status === 0) {
              response.data = {
                message: "Could not contact server"
              };
            }
            
            this.loginError.message = response.data.message;
            this.loginError.show = true;
            this.logUserIn = false;
          }
        );
      },
      switchUser: function() {
        this.$router.replace({
          name: "login",
        })
      },
      goToServicePanelDashboard: function() {
        this.$router.replace({
          name: "dashboard",
        })
      },
      goToSale: function(saleNumber) {
        this.initAuth();
        this.$router.replace({
          name: "search",
          query: {
            saleNumber: saleNumber,
          }
        })
      },
      handlePaste(event) {
        event.preventDefault();
        const pastedData = (event.clipboardData || window.clipboardData).getData('text');
        const digits = pastedData.replace(/\D/g, '').slice(0, 6);
        
        if (digits.length > 0) {
          const fields = ['A', 'B', 'C', 'D', 'E', 'F'];
          fields.forEach((field, index) => {
            this[`otp${field}`] = digits[index] || '';
          });
          
          // Focus on the next empty field or the last field
          const nextEmptyIndex = digits.length < 6 ? digits.length : 5;
          this.$refs[`otpInput${fields[nextEmptyIndex]}`].focus();
          
          // If all 6 digits were pasted, submit automatically
          if (digits.length === 6) {
            this.loginCredentials.otp = digits;
            this.loginToServicePanel();
          }
        }
      },
      handleInput(event, current, next) {
        const value = event.target.value;
        
        // Only keep the last character if multiple were somehow entered
        if (value.length > 1) {
          this[`otp${current}`] = value.slice(-1);
        }
        
        // Only allow digits
        if (!/^\d*$/.test(this[`otp${current}`])) {
          this[`otp${current}`] = '';
          return;
        }
        
        // Move to next field if we have a value
        if (this[`otp${current}`] && next) {
          this.$refs[`otpInput${next}`].focus();
        }
        
        // If this is the last field and it has a value, submit
        if (current === 'F' && this[`otp${current}`]) {
          this.loginCredentials.otp = this.otpA + this.otpB + this.otpC + this.otpD + this.otpE + this.otpF;
          this.loginToServicePanel();
        }
      },
      handleKeydown(event, current, prev) {
        const fields = ['A', 'B', 'C', 'D', 'E', 'F'];
        const currentIndex = fields.indexOf(current);
        
        // Handle backspace to go to previous field
        if (event.key === 'Backspace' && !this[`otp${current}`] && prev) {
          this.$refs[`otpInput${prev}`].focus();
        }
        
        if (event.key === 'ArrowLeft' && currentIndex > 0) {
          event.preventDefault();
          this.$refs[`otpInput${fields[currentIndex - 1]}`].focus();
        }
      
        if (event.key === 'ArrowRight' && currentIndex < 5) {
          event.preventDefault();
          this.$refs[`otpInput${fields[currentIndex + 1]}`].focus();
        }
      },
    },
  }
</script>
<style scoped>
  .input-bg {
    background: #ffffff;
  }
</style>
